import { render, staticRenderFns } from "./CustomerNav.vue?vue&type=template&id=35f39f9c&scoped=true&"
import script from "./CustomerNav.vue?vue&type=script&lang=js&"
export * from "./CustomerNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNav.vue?vue&type=style&index=0&id=35f39f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f39f9c",
  null
  
)

export default component.exports